import http from "../http";

export async function get() {
  const response = await http.get("/user");
  return response.data;
}

export async function put(data) {
  return await http.put("/user", data);
}

export async function getPermissions() {
  const response = await http.get("/user/permissions/v2");
  return response.data;
}

export async function getUserProfile() {
  const response = await http.get("/user/profile");
  return response.data;
}

export async function triggerEmail() {
  const response = await http.post("/user/profile/password-change-mail");
  return response.data;
}

export async function updateUserProfile(data) {
  const response = await http.put("/user/profile", data);
  return response.data;
}
